/* eslint-disable */
import React from 'react';
import PageTitle from '../components/Text/PageTitle';

function PrivacyPolicy() {
  return (
    <section className="hero section section__wide">
      <PageTitle>Privacy policy</PageTitle>
      <p>LAST MODIFIED: 24 March 2023</p>
      <br />
      <p>
        Shajar takes your privacy very seriously. This Privacy Policy explains
        how Shajar collects, uses, and discloses information, and your choices
        for managing your information preferences.
      </p>
      <p>
        This Privacy Policy describes Shajar’s data practices associated with
        our website (shajarthecompany.com/) and Shajar services ("Services"),
        and the choices that Shajar provides in connection with our collection
        and use of your information. This Privacy Policy is intended for website
        publisher customers ("Publishers"), website merchant customers
        ("Merchants") and individual users of websites and apps. For Publishers
        and Merchants, this Policy explains how Shajar may collect, use and
        disclose information associated with your company and with your
        company’s websites and apps that use Shajar Services. For individual
        website and app users, this Privacy Policy explains how Shajar may
        collect, use, and disclose information when you visit our website or
        when you use any website or app that uses Shajar Services.
      </p>
      <p>
        Publishers and Merchants and other clients may also have their own
        policies that govern how they collect, use, and share data. These
        policies may differ from Shajar’s policies described in this Privacy
        Policy. Please consult the privacy policies of the websites you visit
        and apps you use to become familiar with their privacy practices and to
        learn about any choices that these companies may offer with respect to
        their information practices. In addition, any website containing our
        Services may contain links to websites or content operated and
        maintained by third parties, over which we have no control. We encourage
        you to review the privacy policy of a third-party website before
        disclosing any information to the website.
      </p>
      <br />
      <p>1. Information Collection and Use</p>
      <p>
        Shajar collects data in a variety of ways - including through the use of
        log files, pixel tags, cookies, and/or similar technologies. Examples of
        the types of data that we collect are:
      </p>
      <p>
        Browser information (e.g. URL, browser type, ‘click through’ data); Ad
        reporting or delivery data (e.g. size/type of ad, ad impressions,
        location/format of ad, data about interactions with the ad); Device-type
        information (e.g. screen dimensions, device brand and model);
        Information about your activities on our website and Services.
      </p>
      <p>
        We may combine information that does not directly identify an individual
        with data collected from other sources and disclose the combined
        information to participating publishers, advertisers and ad networks so
        that they can determine whether to bid on ad inventory and in order to
        improve the relevance of the advertising presented to users. We also use
        the information we collect to host, operate, maintain, secure, and
        further develop and improve our Services, such as to keep track of
        advertising delivery and to measure the effectiveness of advertising
        delivered through our Services, and investigate compliance with Shajar’s
        policies and terms and conditions. Some of the third parties that we
        work with may contribute additional data to us directly, which we may
        combine with our own in order to help us provide a better service. We do
        not collect any information that could be used to directly identify an
        individual.
      </p>
      <p>
        Shajar does not engage in activities that require parental notice or
        consent under the Children’s Online Privacy Protection Act (COPPA). If
        you believe that Shajar has inadvertently collected information from a
        child under 13 that is subject to parental notice and consent under
        COPPA, please contact Shajar using the contact information below to
        request deletion of the information.
      </p>
      <br />
      <p>2. Cookies and Other Similar Technologies.</p>
      <p>
        We use cookies (a small file containing a string of characters that
        uniquely identifies your Web browser), Web beacons (an electronic file
        placed within a Web site that monitors usage), pixels, tags, and similar
        technologies to operate and improve our website and Services, including
        for interest-based advertising as described below. Some of our Service
        Providers (defined below) may also use such technologies in connection
        with the services they perform on our behalf.
      </p>
      <br />
      <p>3. Information Sharing</p>
      <p>
        We will disclose contact and billing information to third parties only
        as described in this Privacy Policy: with your express permission; with
        our affiliates, which include entities controlling, controlled by, or
        under common control with Shajar; where we contract with third parties
        to provide certain services, such as advertising, analytics, data
        management services, web hosting, and web development ("Service
        Providers"). We ask Service Providers to confirm that their privacy and
        security practices are consistent with ours, we provide our Service
        Providers with only the information necessary for them to perform the
        services we request, and Service Providers are prohibited from using
        such information for purposes other than as specified by Shajar; in the
        event that Shajar is merged, sold, or in the event of a transfer of some
        or all of our assets (including in bankruptcy), or in the event of
        another corporate change, we may disclose or transfer information in
        connection with such transaction; and where we believe it is necessary
        to protect Shajar or our users; to enforce our terms or the legal rights
        of Shajar or others; or to comply with a request from governmental
        authorities, legal process, or other legal obligations.
      </p>
      <p>
        We may also share and disclose other information that we collect,
        including aggregate information, as we consider necessary to develop and
        provide our Services, including in the ways described above. The
        information that we share in this way would not be considered to
        personally identify an individual.
      </p>
      <p>
        Shajar may also be required to disclose information in response to
        lawful requests by public authorities, including to meet national
        security or law enforcement requirements.
      </p>
      <br />
      <p>4. Interest-Based Advertising and Opting Out</p>
      <p>
        Shajar adheres to the Digital Advertising Alliance (DAA) Self-Regulatory
        Principles in the US and to the European Digital Advertising Alliance
        (EDAA) Principles in the EU and the IAB Europe OBA Framework.
      </p>
      <p>
        The Shajar Ad Exchange uses cookies, Web beacons, pixels, tags, and
        similar technologies to give Publishers the possibility to offer, and Ad
        Exchange advertisers the ability to show, targeted ads on the device on
        which you are viewing this policy or a different device. These ads are
        more likely to be relevant to you because they are based on inferences
        drawn from location data, web viewing data collected across
        non-affiliated sites over time, and/or application use data collected
        across non-affiliated apps over time. This is called "interest-based
        advertising." In addition, certain third parties may collect data on the
        Shajar website and combine this data with information collected from
        other websites over time for purposes that include interest-based
        advertising.
      </p>
      <br />
      <p>5. Opting Out for Cookie-Based Services</p>
      <p>
        If you would like to learn more about this type of advertising, or would
        prefer to opt out of website interest-based advertising enabled by
        Shajar’s Ad Exchange, European Union residents may opt-out of this form
        of advertising by companies participating in the EDAA at
        www.youronlinechoices.com and all other users may visit
        www.aboutads.info/choices to opt out of this form of advertising by
        companies participating in the DAA self-regulatory program. Please note
        that in order for your opt-out choice to be effective using this tool,
        you must ensure that your browser is set to accept third-party cookies
        such as the Shajar opt-out cookie. Some browsers block third-party
        cookies by default, and you may need to change your browser settings to
        accept third-party cookies before opting out.
      </p>
      <br />
      <p>
        6. Opting Out for Certain Non-Cookie Services (in applicable countries)
      </p>
      <p>
        To help identify your browser and/or possible relationships between
        different browsers and devices, Shajar or our partners may use the local
        storage or cache in your browser. Using the browser cache or local
        storage helps Shajar or our partners deliver interest-based advertising
        to a browser without the use of third-party cookies. We are using local
        storage only for application processing, not for any tracking processes.
        To opt out of Shajar’s use of local storage or the browser cache to
        provide its services, please (1) use any tools provided by your browser
        to clear local storage and the browser cache, and (2) turn on any "Do
        Not Track" header setting offered by your browser. As long as the two
        steps are completed and maintained on a browser, Shajar will not use
        local storage or the cache on that browser to identify and sync browsers
        and devices. If you also want to opt out of Shajar’s use of third-party
        cookies for interest-based advertising as enabled by Shajar’s Ad
        Exchange, please see instructions above.
      </p>
      <br />
      <p>7. Opting Out for Mobile Application Data</p>
      <p>
        To opt out of Shajar’s collection, use, and transfer of data for
        interest-based advertising on mobile apps, you may download the DAA’s
        AppChoices application from the Android or iOS app store on your mobile
        device. Our document were generated utilizing the resources provided by
        the Privacy Policy Generator. Users outside the United States may not
        have access to this application; instead, you can use "Limit Ad
        Tracking" in your iOS settings or "Opt out of interest-based ads" in
        your Android settings to limit Shajar’s collection of data for
        interest-based advertising.
      </p>
      <br />
      <p>8. Opting Out for Location Data</p>
      <p>
        You may opt out of our collection, use, and transfer of precise location
        data by using the location services controls in your mobile device’s
        settings.
      </p>
      <br />
      <p>9. Effect of Opting Out</p>
      <p>
        If you use a different device or browser, or erase cookies from your
        browser, you will need to renew your opt-out choice.
      </p>
      <p>
        If you opt out of Shajar’s practices, you may continue to receive
        interest-based advertising through other companies. Third-party
        advertisers and ad networks that participate in the Shajar Ad Exchange
        may also use their own cookies and other ad service technologies to
        display and track their ads. We do not control and are not responsible
        for such third-party advertisers and ad networks’ information practices
        or their use of cookies and other ad service technologies. To learn more
        about the practices of these companies, please read their privacy
        policies.
      </p>
      <p>
        Even if you opt-out, Shajar may continue to collect data for other
        purposes. You still will receive advertising from the Shajar Ad Exchange
        when you visit websites of a Publisher who uses our Services – but such
        advertisements will not be targeted to you.
      </p>
      <br />
      <p>10. Reviewing and Updating Information</p>
      <p>
        Shajar takes reasonable steps to ensure that information is accurate,
        complete, current, and reliable for its intended use. For contact or
        billing information submitted through our website, you may review,
        correct, update, or change your information, request that we deactivate
        your account, or remove your information from our direct marketing
        efforts, at any time by emailing us shajarllc@gmail.com.
      </p>
      <br />
      <p>11. International Information Transfers</p>
      <p>
        Please be aware that the information we collect, including contact and
        billing information, may be transferred to and maintained on servers or
        databases located outside your state, province, country, or other
        jurisdiction, where the privacy laws may not be as protective as those
        in your location. If you are located outside of the United States,
        please be advised that we process and store information in the United
        States and your consent to this Privacy Policy or use of Shajar Services
        represents your agreement to this processing.
      </p>
      <br />
      <p>12. Security</p>
      <p>
        Information that we collect is stored using procedures and practices
        reasonably designed to help protect information from unauthorized
        access, destruction, use, modification, or disclosure.
      </p>
      <br />
      <p>13. Policy Updates</p>
      <p>
        From time to time, we may change this Privacy Policy. If we decide to
        change this Privacy Policy, in whole or in part, we will inform you by
        posting the revised Privacy Policy on the Shajar website. Those changes
        will go into effect on the effective date disclosed in the revised
        Privacy Policy.
      </p>
      <br />
      <p>14. Contact Us</p>
      <p>
        If you have any questions or concerns regarding this Shajar Privacy
        Policy, please contact us by emailing us at shajarllc@gmail.com.
      </p>
    </section>
  );
}

export default PrivacyPolicy;
